// extracted by mini-css-extract-plugin
export default {"header":"accordion_header__UIU79","button":"accordion_button__QlkSw","body":"accordion_body__lCtBh","li":"accordion_li__+vcdW"};